import React, {useEffect, useState} from 'react'
import {
  ModeleReferentielFournisseurPOT,
  modeleReferentielFournisseurPOTInitValues,
} from '../../../components/Models'
import {useNavigate, useParams} from 'react-router-dom'
import {editFournisseurPOT, getOneFournisseurPOT} from '../../../components/requests'
import {LoadingData} from '../../../components/LoadingData'
import {ReferentielFournisseurPOTForm} from './components/ReferentielFournisseurPOTForm'
import {useLocation} from "react-router";

type LocationState = {
  allFournisseursPOT: any
}

const ReferentielFournisseurPOTEditPage = () => {
  const navigate = useNavigate()
  let {fournisseurId} = useParams()
  const location = useLocation()
  const state = location.state as LocationState | null
  const [data, setData] = useState<ModeleReferentielFournisseurPOT>(
    modeleReferentielFournisseurPOTInitValues
  )
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getFournisseurPOTData()
  }, [fournisseurId])

  const getFournisseurPOTData = () => {
    getOneFournisseurPOT(fournisseurId)
      .then((fournisseurPOTRequest) => {
        if (fournisseurPOTRequest?.status === 200) {
          if (
            fournisseurPOTRequest?.data?.id !== undefined &&
            fournisseurPOTRequest?.data?.id !== null
          ) {
            const updatedData = Object.assign({...data}, fournisseurPOTRequest?.data)
            setData({...updatedData})
          }
          setLoading(false)
        } else {
          navigate(`/referentiel-fournisseur-pot`)
        }
      })
      .catch((e) => {
        setLoading(false)
        navigate(`/referentiel-fournisseur-pot`)
      })
  }

  const submitForm = async (
    fieldsToUpdate: Partial<ModeleReferentielFournisseurPOT>,
    callback
  ): Promise<void> => {
    const updatedData = Object.assign(
      {...modeleReferentielFournisseurPOTInitValues},
      fieldsToUpdate
    )

    var requestOk = false
    try {
      const fournisseurPOTRequest = await editFournisseurPOT(fournisseurId, updatedData)
      if (fournisseurPOTRequest?.status === 200) {
        requestOk = true
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
      if (requestOk) {
        setData({...updatedData})
        navigate(`/referentiel-fournisseur-pot`)
      }
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Modifier un fournisseur POT</h3>
        </div>
      </div>

      <div>
        {loading ? (
          <LoadingData />
        ) : (
          <ReferentielFournisseurPOTForm
            fournisseurId={fournisseurId}
            data={data}
            submitForm={submitForm}
            allFournisseursPOT={state?.allFournisseursPOT}
          />
        )}
      </div>
    </div>
  )
}

export default ReferentielFournisseurPOTEditPage
